import type {
    AppModule,
    AppSubmodule,
    ExposedMenu,
    MenuGroup,
    SideLink,
} from '@moniebook-web/components/widgets/sidebar';
import { DiscountPercentLine } from '@moniebook-web/icons/finance/discount-percent-line';
import { GiftLine } from '@moniebook-web/icons/finance/gift-line';
import { Crm } from '@moniebook-web/icons/sidebar-rail/crm';
import { GroupLine } from '@moniebook-web/icons/user-faces/group-line';
import { User3Line } from '@moniebook-web/icons/user-faces/user-3-line';
import { UserLine } from '@moniebook-web/icons/user-faces/user-line';
import {
    ApplicationModule,
    MENU_PARENTS,
    MENU_SECTIONS,
} from '@moniebook-web/types';

import { FEATURE_FLAGS, LOYALTY_PAGE_PERMISSIONS } from '@/shared/constants';

const CUSTOMER_SIDEBAR_COLOR = '#542ED0';

export const customersMenu: ExposedMenu = {
    menuGroups: [
        {
            id: MENU_PARENTS.CUSTOMERS,
            sectionId: MENU_SECTIONS.NONE,
            name: 'CRM',
            order: 3,
            icon: <User3Line />,
            color: CUSTOMER_SIDEBAR_COLOR,
        },
    ] as MenuGroup[],
    submenu: [
        {
            sectionId: MENU_SECTIONS.NONE,
            parentId: MENU_PARENTS.CUSTOMERS,
            order: 1,
            accessCodeList: [
                'VIEW_CUSTOMER',
                'MANAGE_CUSTOMER',
                'EXPORT_CUSTOMERS_LIST',
            ],
            name: 'Customers',
            to: '/dashboard/customers?tab=customers',
            grantAccessIfAny: true,
            icon: <User3Line />,
        },
        {
            sectionId: MENU_SECTIONS.NONE,
            parentId: MENU_PARENTS.CUSTOMERS,
            order: 2,
            accessCodeList: [
                'VIEW_CUSTOMER',
                'MANAGE_CUSTOMER',
                'EXPORT_CUSTOMERS_LIST',
            ],
            name: 'Customer Groups',
            to: '/dashboard/customers/groups',
            grantAccessIfAny: true,
            featureFlag: FEATURE_FLAGS.ENABLE_NEW_DESIGN_SYSTEM_CRM,
            icon: <GroupLine />,
        },
        {
            sectionId: MENU_SECTIONS.NONE,
            parentId: MENU_PARENTS.CUSTOMERS,
            order: 3,
            accessCodeList: ['VIEW_DISCOUNT', 'MANAGE_DISCOUNT'],
            name: 'Discounts',
            to: '/dashboard/discounts',
            grantAccessIfAny: true,
            icon: <DiscountPercentLine />,
        },
        {
            sectionId: MENU_SECTIONS.NONE,
            parentId: MENU_PARENTS.CUSTOMERS,
            order: 4,
            accessCodeList: LOYALTY_PAGE_PERMISSIONS,
            name: 'Loyalty',
            to: '/dashboard/loyalty',
            grantAccessIfAny: true,
            featureFlag: FEATURE_FLAGS.ENABLE_LOYALTY,
            icon: <GiftLine />,
        },
    ] as SideLink[],
    modules: [
        {
            id: ApplicationModule.CUSTOMERS,
            name: 'CRM',
            order: 4,
            icon: <Crm />,
            backgroundColor: '#F0DFFF',
            foregroundColor: '#C280FD',
        },
    ] as AppModule[],
    subModules: [
        {
            parentId: ApplicationModule.CUSTOMERS,
            order: 1,
            accessCodeList: [
                'VIEW_CUSTOMER',
                'MANAGE_CUSTOMER',
                'EXPORT_CUSTOMERS_LIST',
            ],
            name: 'Customers',
            to: '/dashboard/customers?tab=customers',
            grantAccessIfAny: true,
            icon: <UserLine />,
        },
        {
            parentId: ApplicationModule.CUSTOMERS,
            order: 2,
            accessCodeList: [
                'VIEW_CUSTOMER',
                'MANAGE_CUSTOMER',
                'EXPORT_CUSTOMERS_LIST',
            ],
            name: 'Customer Groups',
            to: '/dashboard/customers/groups',
            grantAccessIfAny: true,
            featureFlag: FEATURE_FLAGS.ENABLE_NEW_DESIGN_SYSTEM_CRM,
            icon: <GroupLine />,
        },
        {
            parentId: ApplicationModule.CUSTOMERS,
            order: 3,
            accessCodeList: ['VIEW_DISCOUNT', 'MANAGE_DISCOUNT'],
            name: 'Discounts',
            to: '/dashboard/discounts',
            grantAccessIfAny: true,
            icon: <DiscountPercentLine />,
        },
        {
            parentId: ApplicationModule.CUSTOMERS,
            order: 4,
            accessCodeList: LOYALTY_PAGE_PERMISSIONS,
            name: 'Loyalty',
            to: '/dashboard/loyalty',
            grantAccessIfAny: true,
            featureFlag: FEATURE_FLAGS.ENABLE_LOYALTY,
            icon: <GiftLine />,
        },
    ] as AppSubmodule[],
};
